/* Publish by EComposer at 2026-10-23 08:26:49*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-lkc69hdf0v"]=  window.__ectimmers["ecom-lkc69hdf0v"] || {};
if(!this.$el)return;const t=this.$el,e=t.querySelector(".ecom-text_view-more-btn"),i=t.querySelector(".ecom-text_view-less-btn"),s=t.querySelector(".text-content.ecom-html");!s||(e&&e.addEventListener("click",()=>{s.classList.remove("ecom-text--is-mark"),s.style.maxHeight="",e.style.display="none",i.style.display=""}),i&&i.addEventListener("click",()=>{s.classList.add("ecom-text--is-mark"),s.style.maxHeight="var(--ecom-text-height)",i.style.display="none",e.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-lkc69hdf0v').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-lkc69hdf0v', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-n3kyvv652g').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-n3kyvv652g', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-89tauk15qan').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-89tauk15qan', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-fxu3m5sejnh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-fxu3m5sejnh', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-jjr0gjs91qt').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-jjr0gjs91qt', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-yws5vhryetc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-yws5vhryetc', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-l8ldaxdzdse').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-l8ldaxdzdse', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ba54kwnij4').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ba54kwnij4', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-wusptz5r9r').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-wusptz5r9r', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-ikjfc4a7skt"]=  window.__ectimmers["ecom-ikjfc4a7skt"] || {};
const t=this.$el;if(!t)return;const e=t.querySelector("form");let i=this.settings.link_redirect,s=window.location.href,o=this.settings.form_action_after_submit;if(this.isLive){let l=function(){if(!i)return!1;let d=i.href;if(d=="")return!1;let p=i.target;window.location.href.includes("customer_posted=true")&&(p==="_blank"?window.open(d):window.location.href=d)};const n=t.querySelector(".ecom-shopify__newsletter__verify-checkbox"),r=t.querySelector(".ecom-shopify__newsletter__verify-error");if(e&&n){const d=function(p){r&&r.classList.toggle("ecom-dn",!p)};n.addEventListener("invalid",function(p){p.preventDefault(),d(!0)}),e.addEventListener("submit",function(p){n.checked||(p.preventDefault(),p.stopImmediatePropagation(),d(!0))}),n.addEventListener("change",function(){n.checked&&d(!1)})}const a=this.settings.ga4_event_name;if(this.isLive===!0&&e&&a){const d="ecom_nl_ga4_pending",p={form_id:e.id,form_name:this.settings.tracking_id||"newsletter_form",form_destination:"shopify_customer"},m=function(_,b){const y=Object.assign({},p,b||{});typeof window.gtag=="function"&&window.gtag("event",_,y),window.dataLayer&&typeof window.dataLayer.push=="function"&&window.dataLayer.push(Object.assign({event:_},y))};if(e.addEventListener("submit",function(){try{sessionStorage.setItem(d,JSON.stringify({id:e.id,t:new Date().getTime()}))}catch(_){}m("form_submit")}),t.querySelector(".ecom-shopify__newsletter-form-success")){let _=null;try{_=JSON.parse(sessionStorage.getItem(d)||"null")}catch(b){}if(_&&_.id===e.id&&new Date().getTime()-_.t<3e5){try{sessionStorage.removeItem(d)}catch(b){}m(a,{method:"newsletter"})}}}if(o&&o==="popup"){if(s.includes("customer_posted=true")&&e&&e.hasAttribute("data-ecom-popup")){const d=e.getAttribute("data-ecom-popup")||"",p=document.querySelector("#ecom-popup-data");if(!p){console.warn("Ecom popup data element not found");return}const m=JSON.parse(p.innerHTML);if(m){let _=m.find(b=>b.id===d);setTimeout(()=>{_&&window.EComPopup.popupContainerHandler&&window.EComPopup.popupContainerHandler(_)},300)}}return}l();const c=/(\?|&)contact%5Btags%5D=[^&]+&form_type=customer(&|$)/;this.settings.scroll_in_view&&(window.location.pathname.includes("challenge")?setTimeout(function(){var d=document.querySelector(".shopify-challenge__container");d.scrollIntoView()},100):setTimeout(function(){(c.test(location.search)||window.location.href.includes("customer_posted=true"))&&t.scrollIntoView()},300)),c.test(location.search)&&e&&e.querySelector(".ecom-shopify__newsletter-form-message.ecom-dn")&&e.querySelector(".ecom-shopify__newsletter-form-message.ecom-dn").classList.remove("ecom-dn"),e&&e.dataset.ecTrackingId&&e.addEventListener("submit",function(){window.Shopify&&window.Shopify.analytics&&Shopify.analytics.publish("ec_custom_events",{button_id:e.id,tracking_id:e.dataset.ecTrackingId})},{once:!0})}

                    });
                    
                        document.querySelectorAll('.ecom-ikjfc4a7skt').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ikjfc4a7skt', settings: {"form_action_after_submit":"redirect","scroll_in_view":true},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-xyrrntoq6ya"]=  window.__ectimmers["ecom-xyrrntoq6ya"] || {};
if(!this.$el)return!1;const t=this.$el;this.settings.animation&&function(i){if(!t)return;const s=t.querySelector(".ecom__element--button");if(!s)return;let o=parseInt(i.settings.animation_loop_time)*1e3||6e3,n=1e3;window.__ectimmers["ecom-xyrrntoq6ya"]["uwm3in13j"] = setInterval(function(){s.classList.add("animated"),setTimeout(function(){s.classList.remove("animated")},n)},o)}(this);var e=t.querySelector(".ecom__element--button");this.isLive&&e&&e.dataset.ecTrackingId&&e.addEventListener("click",function(i){if(window.Shopify&&window.Shopify.analytics){i.preventDefault();let s=window.EComposer.PAGE||window.EComposer.TEMPLATE||window.EComposer.SECTION||window.EComposer.BLOCK||{};const o=Object.assign({button_id:e.id,tracking_id:e.dataset.ecTrackingId},s);try{Shopify.analytics.publish("ec_custom_events",o)}catch(a){console.error("[EC Tracking] Error publishing analytics event:",a)}const n=e.getAttribute("href"),r=e.getAttribute("target");n&&n!=="#"&&n!=="javascript:void(0)"&&(r==="_blank"?window.open(n,"_blank"):setTimeout(function(){window.location.href=n},300))}},{once:!0}),this.isLive&&e&&e.dataset.eventTrackingFb&&e.addEventListener("click",function(i){window.fbq&&window.fbq("track",`${e.dataset.eventTrackingFb}`)},{once:!0})

                    });
                    
                        document.querySelectorAll('.ecom-xyrrntoq6ya').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xyrrntoq6ya', settings: {"animation":false},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-oxuaz5ntfnk"]=  window.__ectimmers["ecom-oxuaz5ntfnk"] || {};
const t=function(r){if(window.EComModal)return r();if(window.EComposer&&typeof window.EComposer.loadVendor=="function"){window.EComposer.loadVendor("modal_js").then(function(){window.EComModal&&r()});return}let a=0;const l= window.__ectimmers["ecom-oxuaz5ntfnk"]["2zrnsp6vi"] = setInterval(function(){window.EComModal?(clearInterval(l),r()):++a>=300&&clearInterval(l)},50)};if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&this.$el){var e=this.$el.querySelector("[ecom-modal]"),i=this.id;t(function(){new window.EComModal(e,{cssClass:["ecom-container-lightbox-"+i]})})}let s=this.$el;if(!s)return;function o(r){const a=r.getBoundingClientRect();return a.top>=0&&a.left>=0&&a.bottom-r.offsetHeight/2<=(window.innerHeight||document.documentElement.clientHeight)&&a.right<=(window.innerWidth||document.documentElement.clientWidth)}function n(){let r=s.querySelector(".ecom-element.ecom-base-image"),a=s.closest(".core__row--columns");r&&(o(r)?(r.classList.add("image-highlight"),a.setAttribute("style","z-index: unset")):(r.classList.remove("image-highlight"),a.setAttribute("style","z-index: 1")))}this.settings.highligh_on_viewport&&window.addEventListener("scroll",function(){n()})

                    });
                    
                        document.querySelectorAll('.ecom-oxuaz5ntfnk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-oxuaz5ntfnk', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ph1mao8tcv').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ph1mao8tcv', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9s84eqwrwat').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9s84eqwrwat', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-mdcritzliqf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-mdcritzliqf', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-92u8e4tq5tb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-92u8e4tq5tb', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-n5c0q9cma8h"]=  window.__ectimmers["ecom-n5c0q9cma8h"] || {};
var e=this.$el;if(e&&this.isLive){var t=e.querySelectorAll(".element-social-link:not(.element-social-link__custom)");t.length&&t.forEach(function(i){var a=i.getAttribute("href")||"#",r=a.replace("{current-link}",location.href);i.setAttribute("href",r)})}

                    });
                    
                        document.querySelectorAll('.ecom-n5c0q9cma8h').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-n5c0q9cma8h', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-mfvo9izmot"]=  window.__ectimmers["ecom-mfvo9izmot"] || {};
const $el = this.$el;
                if(!$el) return;
                const isLive = this.isLive,
                    content = this.settings.content,
                    type = this.settings.type,
                    sroll_block = this.settings.sroll_block || 'start',
                    offsetTop = parseInt(this.settings.offsetTop) || 0,
                    offsetTop__tablet = parseInt(this.settings.offsetTop__tablet) || 0,
                    offsetTop__mobile = parseInt(this.settings.offsetTop__mobile) || 0;
                if(!isLive) return;
                    /* Image Sticky */
                if(this.settings.enable_position_sticky &&  window.innerWidth > 1024) {
                    if($el.parentElement) {
                        if(this.isLive) {
                            $el.style.height = "100%";
                        } else {
                            $el.parentElement.style.height = "100%";
                        }
                    }
                }
                function capitalizeFirstLetter(string) {
                    return string.charAt(0).toUpperCase() + string.slice(1);
                }
                let spaceTop = offsetTop;
                if(window.innerWidth < 1024 && window.innerWidth > 768) {
                    spaceTop = offsetTop__tablet
                }
                if(window.innerWidth <= 768) {
                    spaceTop = offsetTop__mobile
                }
                if(content === 'full_page') {
                    let main = $el.closest('.ecom-builder'),
                        el_content = $el.querySelector('.ecom-blog-table-of-content-wrapper');
                    let show_index = this.settings.index ?? false,
                        show_index2 = this.settings.index2 ?? false,
                        icon = this.settings.icon ?? false;
                    if(!el_content) return;
                    let tag = this.settings.tag, tag2 = this.settings.tag2;
                    if(type === 'css') {
                        tag = this.settings.css_heading;
                        tag2 = this.settings.css_heading2;
                    }
                    let allHeading = main.querySelectorAll(`${tag}, ${tag2}`);
                    let tocUl = document.createElement("ul"),
                        tocFragment = new DocumentFragment(),
                        mainLi = null,
                        subUl = null,
                        subLi = null,
                        isSibling = false,
                        idx = 0,
                        idx2 = 0,
                        count = 0;
                    tocUl.className = 'ecom-blog-table-of-content__items ecom-blog-table-of-content__items-index';
                    if(tag){
                        tag = tag.replace('#', '');
                        tag = tag.replace('.', '');
                    }
                    if(tag2){
                        tag2 = tag2.replace('#', '');
                        tag2 = tag2.replace('.', '');
                    }
                    if(allHeading.length > 0){
                        allHeading.forEach(function(element, index) {
                            let level = element.nodeName;
                            if(tag.includes(' ')){
                              tag = tag.split(' ')[tag.split(' ').length - 1];
                            }
                            if(tag2 && tag2.includes(' ')){
                              tag2 = tag2.split(' ')[tag2.split(' ').length - 1];
                            }
                            if(level.toLowerCase() === tag || element.classList.contains(tag) || element.id === tag) {
                                idx++;
                                idx2=0;
                            }
                            let anchor = document.createElement("a");
                            let anchorText = element.innerText;
                            // let anchorText = capitalizeFirstLetter(element.innerText.toLowerCase());
                            let elementId = anchorText.replaceAll(" ", "");
                            // element.id = elementId;
                            anchor.href = "#" + elementId;
                            anchor.className = 'ecom-table-content__nav ecom-flex';
                            anchor.setAttribute('data-tag', level.toLowerCase());
                            if (tag2 && (tag2.toUpperCase() === level || element.classList.contains(tag2) || element.id === tag2)) {
                                if (mainLi) {
                                    idx2++;
                                    subLi = document.createElement("li");
                                    subLi.className = 'ecom-flex';
                                    show_index2 ? anchor.innerHTML = `<span>${idx}.${idx2}- ${anchorText}</span>` : anchor.innerHTML = `<span>${anchorText}</span>`;
                                    if(icon) {
                                        let el_icon = document.createElement('span');
                                        el_icon.className = 'ecom__element--blog-table-of-content__icon';
                                        el_icon.innerHTML = icon
                                        anchor.prepend(el_icon);
                                    }
                                    subLi.appendChild(anchor);

                                    if (isSibling === false) {
                                        subUl = document.createElement("ul");
                                        subUl.className = 'ecom-blog-table-of-content__items ecom-blog-table-of-content__items-child';
                                    }
                                    subUl.appendChild(subLi);
                                    mainLi.appendChild(subUl);

                                    isSibling = true;
                                }
                                else {
                                    count++;
                                }
                            } else {
                                mainLi = document.createElement("li");
                                mainLi.className = 'ecom-flex';
                                show_index ? anchor.innerHTML = `<span>${idx}- ${anchorText}</span>` : anchor.innerHTML = `<span>${anchorText}</span>`;
                                if(icon) {
                                    let el_icon = document.createElement('span');
                                    el_icon.className = 'ecom__element--blog-table-of-content__icon';
                                    el_icon.innerHTML = icon
                                    anchor.prepend(el_icon);
                                }
                                mainLi.appendChild(anchor);
                                tocFragment.appendChild(mainLi);
                                isSibling = false;
                                subUl = null;
                            }
                        });
                        tocUl.append(tocFragment);
                        el_content.append(tocUl);
                    } else {
                        el_content.style.display = "none";
                    }
                    let navs = $el.querySelectorAll('.ecom-table-content__nav');
                    if(!navs || !allHeading || navs.length < 1) {
                        $el.style.display = 'none';
                        return;
                    };
                    
                    navs.forEach(function(nav, index) {
                        nav.addEventListener('click', function(e) {
                            e.preventDefault();
                            e.stopPropagation();
                            // handle active text
                            navs.forEach(function(nav) {
                                nav.classList.remove('ecom-text-active');
                            });
                            nav.classList.add('ecom-text-active');
                            //scroll in to view
                            const top = allHeading[index+count].getBoundingClientRect().top + window.pageYOffset - spaceTop;
                            // allHeading[index+count].scrollIntoView({ behavior: 'smooth', block: sroll_block});
                            window.scrollTo({
                                top: top,
                                left: 0,
                                behavior: "smooth",
                                block: sroll_block
                            });

                            // scroll_to_el(this);
                        })
                    });
                    allHeading.forEach(function(heading, index) {
                        if(index < count) return;
                        heading.classList.add('ecom-heading__table-of-content');
                        heading.id = heading.innerText.replaceAll(' ', ''); // optimize SEO
                    });
                    let headings = document.querySelectorAll('.ecom-heading__table-of-content');
                    handleScroll(headings, navs);
                }
                else {
                    let navs = $el.querySelectorAll('.ecom-table-content__nav');
                    if(!navs || navs.length < 1) {
                        $el.style.display = 'none';
                        return;
                    };
                    navs.forEach(function(nav) {
                        let tag = nav.dataset.tag;
                        if(tag) {
                            const content = nav.querySelector('span').textContent;
                            const symbol = content.includes('"') ? "'" : '"';
                            const xpath = `//${tag}[contains(.,` + `${symbol}${content}${symbol})]`
                            var headings = document.evaluate(`${xpath}`, document, null, XPathResult.ANY_TYPE, null );
                            var thisHeading = headings.iterateNext();
                            if(thisHeading) {
                               thisHeading.classList.add('ecom-heading__table-of-content')
                               thisHeading.id = thisHeading.innerText.replaceAll(' ', ''); // optimize SEO
                            }
                        }
                        nav.addEventListener('click', function(e) {
                            e.preventDefault();
                            e.stopPropagation();
                            // handle active text
                            navs.forEach(function(nav) {
                                nav.classList.remove('ecom-text-active');
                            });
                            nav.classList.add('ecom-text-active');
                            scroll_to_el(this);
                        })
                    });
                    let headings = document.querySelectorAll('.ecom-heading__table-of-content');
                        handleScroll(headings, navs);
                }
                // scroll change active
                function handleScroll(headings, navs) {
                    let viewPort = window.innerHeight;
                    window.addEventListener('scroll', function(e) {
                        headings.forEach((heading, index)=>{
                            let check = false;
                            if(heading.getBoundingClientRect().top < 80 && heading.getBoundingClientRect().top > 0 && heading.getBoundingClientRect().top < viewPort) {
                            navs.forEach((nav,idx)=>{
                                nav.classList.remove('ecom-text-active')
                            })
                            navs[index].classList.add('ecom-text-active');
                            }
                            let count = 0;
                            headings.forEach(()=>{

                            if(heading.getBoundingClientRect().top < viewPort && heading.getBoundingClientRect().top > 0) count++
                            });
                            if(count >1) check = true;
                            if(heading.getBoundingClientRect().top < 0 && check) {
                            navs[index].classList.remove('ecom-text-active');
                            }
                            //handle scroll .........
                            // if(heading.getBoundingClientRect().top > viewPort && index >0 && navs[index].className.includes('ecom-text-active')) {
                            //   console.log('greater');
                            //   navs.forEach((nav,idx)=>{
                            //     nav.classList.remove('ecom-text-active')
                            //   })
                            //   navs[index-1].classList.add('ecom-text-active');
                            // }
                        });
                    });
                }
                function scroll_to_el(el) {
                    var tag = el.dataset.tag;
                    if(tag) {
                        const content = el.querySelector('span').textContent;
                        const symbol = content.includes('"') ? "'" : '"'
                        const xpath = `//${tag}[contains(.,` + `${symbol}${content}${symbol})]`
                        // const xpath = `//${tag}[contains(.,` + `${nav.querySelector('span').textContent})]`;
                        var headings = document.evaluate(xpath, document, null, XPathResult.ANY_TYPE, null );
                        var thisHeading = headings.iterateNext();
                        if(thisHeading) {
                            thisHeading.scrollIntoView({ behavior: 'smooth', block: sroll_block});
                            const top = thisHeading.getBoundingClientRect().top + window.pageYOffset - spaceTop;
                            // allHeading[index+count].scrollIntoView({ behavior: 'smooth', block: sroll_block});
                            window.scrollTo({
                                top: top,
                                left: 0,
                                behavior: "smooth",
                                block: sroll_block
                            });
                            // window.scrollBy(0, -offsetTop);
                        }
                    }
                }
                //Show_hide_element
                var btn_switch = $el.querySelector('.ecom-blog-table-of-content_btn-switch'),
                    wrapper = $el.querySelector('.ecom-blog-table-of-content-wrapper');
                if(btn_switch && wrapper) {
                    btn_switch.addEventListener('click', function() {
                        var wrapper = $el.querySelector('.ecom-blog-table-of-content-wrapper');
                        if(wrapper) {
                            wrapper.style.display = (wrapper.style.display == 'none') ? 'block' : 'none';
                        }
                    })
                }

                    });
                    
                        document.querySelectorAll('.ecom-mfvo9izmot').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-mfvo9izmot', settings: {"content":"full_page","type":"tag","sroll_block":"start","index":true,"index2":true,"tag":"h2","tag2":"h3"},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}